'use client';

import React, {createContext, useContext} from 'react';

interface AssetImageContextType {
    preloadedAssetImage: React.ReactNode;
}

const AssetImageContext = createContext<AssetImageContextType | null>(null);

interface AssetImageProviderProps {
    children: React.ReactNode;
    preloadedAssetImage: React.ReactNode;
}

export const AssetImageProvider = ({children, preloadedAssetImage}: AssetImageProviderProps) => {
    return (
        <AssetImageContext.Provider value={{preloadedAssetImage}}>
            {children}
        </AssetImageContext.Provider>
    );
};

export const useAssetImage = (): AssetImageContextType => {
    const context = useContext(AssetImageContext);
    if (!context) {
        throw new Error('useAssetImage must be used within an AssetImageProvider');
    }
    return context;
};
